import React from 'react'
import { MapPin } from 'lucide-react'
import { PiMapPinFill } from 'react-icons/pi';
import type { Restaurant } from '../../../Manager/restaurant.types';

interface LocalAreasProps {
    localAreas?: string[];
    areaClick: (area: string) => void;
}

const LocalAreas = ({ localAreas, areaClick }: LocalAreasProps) => {
  return (
      <div className="">
        <h2 className="text-lg ml-2 font-bold poppins-semibold text-[#bf491e]">Local favorites</h2>
        <p className="text-sm text-gray-500 ml-2 mb-2">Explore areas around you</p>
        <div className="flex gap-3 overflow-x-auto pb-2 scrollbar-hide">
          {localAreas.map((area, idx) => (
            <div key={idx} className="flex-shrink-0" onClick={() => areaClick(area)}>
              <div className="flex items-center gap-3 bg-[white] rounded-full shadow-sm border border-gray-200 px-4 py-3 hover:shadow-md transition-shadow">
                <PiMapPinFill className="w-5 h-5 text-[#ee5219] flex-shrink-0" />
                <span className="max-w-30 font-medium text-gray-900 whitespace-nowrap truncate">{area}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
  )
}

export default LocalAreas